var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_843_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 29,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29 0H0V28H29V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_843_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.1334 9.72579C26.1505 9.97532 26.1505 10.2249 26.1505 10.4767C26.1505 18.1501 20.3719 27 9.80555 27V26.9954C6.68417 27 3.62766 26.0962 1 24.3919C1.45387 24.4471 1.91001 24.4748 2.3673 24.4759C4.95401 24.4782 7.46679 23.6008 9.50179 21.9852C7.04363 21.938 4.88803 20.3178 4.13499 17.9524C4.9961 18.1203 5.88336 18.0858 6.72854 17.8524C4.04855 17.3049 2.12045 14.9246 2.12045 12.1602V12.0866C2.91899 12.5362 3.81308 12.7857 4.72764 12.8133C2.20349 11.108 1.42543 7.71342 2.94971 5.05938C5.8663 8.68741 10.1695 10.893 14.789 11.1264C14.326 9.10942 14.9585 6.99586 16.4509 5.578C18.7646 3.37934 22.4035 3.49203 24.5784 5.82983C25.865 5.5734 27.098 5.09619 28.2265 4.42003C27.7977 5.76429 26.9002 6.90617 25.7012 7.63177C26.8398 7.49608 27.9523 7.1879 29 6.71758C28.2288 7.8859 27.2573 8.90359 26.1334 9.72579Z",
    fill: "#F0F1F9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.75506c3bc3e97c33b81691eeea58e21e.svg";
export { ForwardRef as ReactComponent };